module.exports = __webpack_public_path__ + "img/Mark.9eb97beb.jpg";